import cn from './index.module.css'
import { declOfNum } from '@/helpers/declOfNum'
import FieldWrapper from '@pages/Admin/CourseSettings/components/FieldWrapper/FieldWrapper'

const ShowTariffValue = ({
  tariff,
  value,
}: {
  tariff: ICourseTariff
  value: number
}) => {
  const getPeriodString = (): string => {
    switch (tariff?.type) {
      case 'hour':
        return `${value} ${declOfNum(value, ['час', 'часа', 'часов'])}`
      case 'minute':
        return `${value} ${declOfNum(value, ['минута', 'минуты', 'минут'])}`
      case 'month':
        return `${value} ${declOfNum(value, ['месяц', 'месяца', 'месяцев'])}`
      case 'stream_custom_period':
        return `${value} ${declOfNum(value, ['месяц', 'месяца', 'месяцев'])}`
      case 'stream_custom_days':
        return `${value} ${declOfNum(value, ['день', 'дня', 'дней'])}`

      default:
        return ''
    }
  }

  return (
    <div className={cn.wrapper}>
      <FieldWrapper label="Длительность">
        <div className={cn.valueWrapper}>{getPeriodString()}</div>
      </FieldWrapper>
    </div>
  )
}

export default ShowTariffValue
